import { MaterialAutocomplete, MaterialGrid, MaterialTextField } from '@ezbobdev/ui-widgets-ezbob';

import { useAddressAutocomplete } from './useAddressAutocomplete';

const AddressAutocomplete = ({ houseNumberFieldName = '' }) => {
  const {
    cityResults,
    streetResults,
    cityValue,
    addressValue,
    streetInputValue,
    handleCityValueChange,
    handleCityInputChange,
    handleStreetInputChange,
  } = useAddressAutocomplete();

  return (
    <>
      <MaterialAutocomplete
        name="applicant.address.town"
        values={cityResults}
        MUIAutocompleteProps={{ value: cityValue || null }}
        onChange={handleCityValueChange}
        onInputChange={handleCityInputChange}
        className="widget"
        fullWidth
      />
      <MaterialGrid container spacing={2}>
        <MaterialGrid item xs={houseNumberFieldName ? 9 : 12}>
          <MaterialAutocomplete
            disabled={!cityValue}
            MUIAutocompleteProps={{ value: addressValue || null }}
            name="applicant.address.line1"
            values={streetResults}
            inputValue={streetInputValue}
            onInputChange={handleStreetInputChange}
            className="widget"
            fullWidth={!houseNumberFieldName}
          />
        </MaterialGrid>

        {houseNumberFieldName && (
          <MaterialGrid item xs={3}>
            <MaterialTextField name={houseNumberFieldName} className="widget" />
          </MaterialGrid>
        )}
      </MaterialGrid>
    </>
  );
};

export default AddressAutocomplete;
